import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { LexbeCase } from '../models/case.model';
import { ErrorHandlerService } from './error-handler.service';
import { CustomCaseFieldValue } from '../models/custom-case-field-value.model';

@Injectable({
  providedIn: 'root'
})
export class CustomCaseFieldValueService {
  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  public update(customCaseFieldValue: CustomCaseFieldValue) {
    return this.http.put(`${this.appConfigService.getConfig().webApi}/api2/CustomCaseFieldValues/${customCaseFieldValue.fieldId}`, customCaseFieldValue)
      .pipe(catchError(this.errorHandler.handleError<LexbeCase>(`[PUT] customCaseFieldValue failed for FieldId=${customCaseFieldValue.fieldId}`)));
  }
}
